import { render, staticRenderFns } from "./Sand.vue?vue&type=template&id=1c81e0e0&scoped=true&"
import script from "./Sand.vue?vue&type=script&lang=js&"
export * from "./Sand.vue?vue&type=script&lang=js&"
import style0 from "./Sand.vue?vue&type=style&index=0&id=1c81e0e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81e0e0",
  null
  
)

export default component.exports